export const SCORE_FIELDS = ['taste', 'look'];

const clampScore = value => {
  const number = Number(value);
  return Number.isFinite(number) ? Math.max(1, Math.min(5, Math.round(number))) : 3;
};

// A look field identifies the new five-point format. Older entries used
// appearance and a ten-point scale; convert them without rewriting the database.
export function normalizeScores(scores) {
  if (!scores) return { taste: 3, look: 3 };
  if (scores.look != null) {
    return { taste: clampScore(scores.taste), look: clampScore(scores.look) };
  }
  return {
    taste: scores.taste == null ? 3 : clampScore(Number(scores.taste) / 2),
    look: scores.appearance == null ? 3 : clampScore(Number(scores.appearance) / 2),
  };
}

export function averageScore(scores) {
  const normalized = normalizeScores(scores);
  return (normalized.taste + normalized.look) / 2;
}

